import { LeadPriority } from '@app/models/enums'
import { IFeedItem } from '@app/models/FeedItem'
import { bindFunctions } from '@app/utils/class'
import { formatDate, humanize } from '@app/utils/formatting'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { List } from 'immutable'
import * as React from 'react'

export interface IItemLeadsListProps {
  className?: string
  displayArchivedLeads?: boolean
  leads: List<IFeedItem>
  onArchive: (id: string) => void
  onClick: (id: string) => void
  style?: React.CSSProperties
}

export default class ItemLeadsList extends React.PureComponent<
  IItemLeadsListProps
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    if (this.props.leads.size === 0) {
      return (
        <div className={this.props.className} style={this.props.style}>
          No Leads
        </div>
      )
    }

    const leads = this.props.leads
      .filter((item: any) =>
        !this.props.displayArchivedLeads && item.isArchived ? false : true,
      )
      .map((l, i) => {
        if (l === undefined || i === undefined) {
          return null
        }

        let priorityIconName: IconName
        let iconClasses: string | undefined
        priorityIconName = 'minus-circle'

        switch (l.leadPriority) {
          case LeadPriority.High:
            iconClasses = 'text-danger'
            priorityIconName = 'exclamation-circle'
            break

          case LeadPriority.Low:
            iconClasses = 'text-info'
            priorityIconName = 'arrow-alt-circle-down'
            break

          default:
            priorityIconName = 'minus-circle'
            break
        }

        const itemClasses = classNames('d-flex p-2 align-items-center', {
          'striped-row': i % 2 === 0,
        })

        return (
          <a
            className={itemClasses}
            onClick={() => this._clickedRow(l.id)}
            key={l.id}
          >
            <div className='mr-2'>
              <FontAwesomeIcon
                className={`mr-2 ${iconClasses}`}
                icon={['fal', priorityIconName]}
              />
            </div>
            <div className='mr-4' style={{ width: '100px' }}>
              {humanize(l.leadType)}
            </div>
            <div className='flex-grow-1'>
              <div>{l.title}</div>
            </div>
            <div className='align-self-center'>
              {formatDate(l.dateCreated, 'MM/DD/YYYY')}
            </div>
            <div className='ml-4' style={{ width: '20px' }}>
              {l.isArchived === false && (
                <a
                  className='text-primary'
                  onClick={(e) => {
                    e.stopPropagation()
                    this._clickedArchive(l.id)
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'archive']} />
                </a>
              )}
            </div>
          </a>
        )
      })

    return (
      <div className={this.props.className} style={this.props.style}>
        {leads}
      </div>
    )
  }

  private _clickedArchive(id: string) {
    this.props.onArchive(id)
  }

  private _clickedRow(id: string) {
    this.props.onClick(id)
  }
}
